import type { AnyAction, Middleware } from 'redux';
import { doRefreshToken, types as authTypes } from '../../actions/backendAuth';
import { fetchProfile } from '../../actions/backendProfile';
import { reload } from '../../actions/backendCommon';
import { errorCodes } from '../../../utils/utils';
import { ERR_REFRESH_FAILED } from '../../../constants/backend';
import { hasExceededAuthFailLimit, incrementAuthFailCount, resetAuthFailCount, setAppPaused } from '../../../utils/appPause';
import { reloadPage } from '../../../utils/browser';
import { dispatchBackend } from '../../types/backend';
import { getAuthStore, isAuthWithPasswordEnabled } from '../../selectors/auth';

export const REFRESH_TOKEN_THRESHOLD = 15 * 60 * 1000; // 15 min

const auth: Middleware = store => {
    const { getState } = store;
    return next => (action: AnyAction) => {
        const nextAction = next(action);

        const state = getState();

        switch (action.type) {
            case authTypes.AUTH_SUCCESS: {
                // Refresh token every 15 min
                setInterval(() => doRefreshToken(getAuthStore(getState()), false, store.dispatch), REFRESH_TOKEN_THRESHOLD);

                dispatchBackend(store.dispatch, fetchProfile());

                break;
            }
            case authTypes.AUTH_FAIL: {
                if (!isAuthWithPasswordEnabled(state) || action.payload?.message === ERR_REFRESH_FAILED) {
                    if (hasExceededAuthFailLimit()) {
                        resetAuthFailCount();
                        setAppPaused(true);
                        reloadPage();
                    } else {
                        incrementAuthFailCount();

                        dispatchBackend(
                            store.dispatch,
                            reload({
                                code: errorCodes.background.AUTH_FAILED,
                                reason: 'AUTH_FAILED'
                            })
                        );
                    }
                }
                break;
            }
            default:
        }

        return nextAction;
    };
};

export default auth;
